import React from 'react';
import styled from 'styled-components';
import UserUpdate from './UserUpdate';

const HeaderContainer = styled.header`
  font-family: ${({ theme }) => theme.fonts.main};
  background-color: ${({ theme }) => theme.colors.secondary};
  border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
  display: flex;
  align-items: center;
  box-shadow: 25px 21px 19px 8px rgba(0, 0, 0, 0.51);
  flex-wrap: nowrap;
  align-content: space-between;
  justify-content: space-between;
  box-shadow: 25px 21px 19px 8px rgba(0,0,0,0.51);
`;

const HeaderTitle = styled.h2`
  margin: 0;
  text-align: end;
  flex: 1;
  padding: 0px 30px;
`;

const UserInfoContainer = styled.div`
  display: flex;
  justify-content: space-between; /* Space out the user info and the title */
  align-items: center;
  margin-bottom: 10px; /* Space between user info and the title */
  flex: 1;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  flex: 1;
  padding: 0px 30px;
`;

const UserImage = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
`;

const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
`;

const getRandomGreyShade = () => {
    const greyValue = Math.floor(Math.random() * 256);
    return `#${greyValue.toString(16).padStart(2, '0')}${greyValue.toString(16).padStart(2, '0')}${greyValue.toString(16).padStart(2, '0')}`;
};

const getInitials = (name) => {
  return name.split(' ').map(word => word[0]).join('').toUpperCase();
};

const Header = ({ account, guestMode, userInfo, showUpdate, setShowUpdate, title }) => {
  const handleUserInfoClick = () => {
    setShowUpdate(!showUpdate);
  };

  const truncatedAccount = account ? account.slice(-9) : '';
  const avatarColor = getRandomGreyShade();
  const avatarInitials = userInfo?.name ? getInitials(userInfo.name) : '?';

  return (
    <HeaderContainer>
        <>
          {account && (
            <UserInfoContainer>
              <UserInfo onClick={handleUserInfoClick}>
                <UserImage color={avatarColor}>
                  {avatarInitials}
                </UserImage>
                <UserDetails>
                  <strong>{truncatedAccount}</strong>
                  <strong>{userInfo?.name || 'Not set'}</strong>
                </UserDetails>
              </UserInfo>
              <HeaderTitle>{title}</HeaderTitle>
            </UserInfoContainer>
          )}
          {showUpdate && <UserUpdate showUpdate={showUpdate} setShowUpdate={setShowUpdate} />}
        </>
    </HeaderContainer>
  );
};

export default Header;
